var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessagesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1643 0H3.83695C1.90508 0 0.339844 1.41434 0.339844 3.15997V7.4608C0.339844 8.90887 1.41844 10.1292 2.88901 10.5027L2.17439 14L5.39818 10.6208H14.1629C16.0948 10.6208 17.6601 9.20644 17.6601 7.4608V3.15997C17.6614 1.41434 16.0962 0 14.1643 0Z",
    fill: "#2839D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesIcon);
export default __webpack_public_path__ + "static/media/messages_icon.5cf0be63ba3119c261f7136e498e09c1.svg";
export { ForwardRef as ReactComponent };